import _ from 'lodash'

export const checkRight = (rights, right_uuid) => {

    const right = _.find(rights || [], item => item.uuid === right_uuid)

    if (right && right.hasOwnProperty('hasAccess') && right.hasAccess) {
        return true
    }

    // TODO: Implement this later.
    // if (right && right.hasOwnProperty('periodLimit') && ...) {}
    // if (right && right.hasOwnProperty('limit') && ...) {}

    return false
}